<template>
  <div>
    <div>
      <div class="header-confirmation mb-3 mt-3">ยืนยันการจอง</div>
      <div class="header-detail mb-3">
        เมื่อทำการยืนยันอีเมลแล้ว กด <span>“ยืนยันการจอง”</span>
        ระบบจะทำการจองห้องให้คุณและเจ้าหน้าที่จะทำการติดต่อคุณกลับเพื่อยืนยันการจองไปในเวลาทำการ
      </div>
      <div class="contact-detail mb-3">
        หากมีปัญหากรุณาติดต่อ 1749 หรือ อีเมล support@ccconferance.com
      </div>
      <div class="more-detail-input mb-3">
        <div class="more-detail mb-1">ชื่อ event</div>
        <div class="detail-input">
          <el-input
            :value="value.name"
            type="text"
            @input="handleChangeValue('name', $event)"
          ></el-input>
        </div>
      </div>
      <div class="more-detail-input mb-3">
        <div class="more-detail mb-1">รายละเอียดเพิ่มเติม</div>
        <div class="detail-input">
          <el-input
            :value="value.detail"
            :placeholder="'ใส่รายละเอียดเพิ่มเติม'"
            type="textarea"
            @input="handleChangeValue('detail', $event)"
          ></el-input>
        </div>
      </div>
      <div class="line mb-3"></div>
      <div class="mb-3">
        <div class="more-info">Holding Your Reservation</div>
        <div class="info">
          We will need a credit card number to reserve your room.
        </div>
      </div>
      <div class="mb-3">
        <div class="more-info">Modifying Your Reservation</div>
        <div class="info">
          Please note that a change in the length or dates of your reservation
          may result in a rate change.
        </div>
      </div>
      <div class="mb-5">
        <div class="more-info">Cancelling Your Reservation</div>
        <div class="info">
          You may cancel your reservation for no charge before 11:59 PM. Please
          note that we will assess a fee if you must cancel after this deadline.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Input } from "element-ui"

export default {
  components: {
    "el-input": Input,
  },
  props: {
    value: {
      type: null,
      default: undefined,
    },
  },
  methods: {
    handleChangeValue(key, value) {
      const params = {
        ...this.value,
        [key]: value,
      }

      this.$emit("input", params)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";

.header-confirmation {
  font-size: $font-24;
  font-weight: bold;
}

span {
  color: $color-orange;
}

.more-detail {
  font-weight: bold;
}

.line {
  border-top: 1px solid $light-gray-2;
}

.more-info {
  font-size: $font-20;
}

textarea {
  min-height: 145px;
}

@media screen and (max-width: $sx-size) {
  .header-detail {
    font-size: $font-14;
  }

  .header-confirmation {
    font-size: $font-22;
  }

  .more-info {
    font-size: $font-18;
  }

  .info {
    font-size: $font-14;
  }
}
</style>
